<div *ngIf="isLoaded && !hasOrders" class="row">
    <div class="col">
        <p class="alert alert-info">No payments currently exist. When you make a payment your payment history will show up here</p>
    </div>
</div>

<table *ngIf="hasOrders" class="table-striped table">
    <thead class="secondary-color white-text">
        <tr>
            <td>Id</td>
            <td>Amount</td>
            <td>Status</td>
            <td>Date</td>
            <td>Last Update Date</td>
            <td># Items</td>
            <td>View</td>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let order of orders">
            <td>{{order.id}}</td>
            <td>${{order.total| number:'1.2-2'}}</td>
            <td>{{order.status}}</td>
            <td>{{order?.creation_date| date:'short'}}</td>
            <td>{{order?.last_update_date| date:'short'}}</td>
            <td>{{order.orderItems?.length}}</td>
            <td>
                <a class="btn btn-sm btn-primary" [routerLink]="['/admin','my-account','order',order.id]">
                    <i class="fa fa-eye"></i>
                </a>
            </td>
        </tr>
    </tbody>
</table>
<input class="btn btn-primary" type="button" (click)="loadMore()" 
*ngIf="hasMoreResults()" 
value="Load More" />


// WEBPACK FOOTER //
// ./src/app/admin/order-history/order-history.component.html